import { Component, EventEmitter, Input, Output } from '@angular/core';
import { baseCssConfigStyle } from '@finxone-platform/shared/sys-config-types';

@Component({
  standalone: false,
  selector: 'finxone-web-frontend-copy-share',
  templateUrl: './copy-share.component.html',
})
export class CopyShareComponent {
  @Output() copyContentValue = new EventEmitter<string>();
  @Input() textContentTemplate: string;
  @Input() textAlignment: baseCssConfigStyle;
  @Input() contentStyle: baseCssConfigStyle;
  @Input() leftIcon: string;
  @Input() rightIcon: string;
  @Input() rightIconStyle: baseCssConfigStyle;
  @Input() leftIconStyle: baseCssConfigStyle;
  @Input() copyContentTemplate: string;
  @Input() globalStylingClass = '';
  @Input() isAllowedGlobalStyling = false;
  @Input() useCustomTemplate = false;

  public copyContent() {
    this.copyContentValue.emit(this.copyContentTemplate);
  }
}
